import { createContext, useContext, useState, useMemo } from 'react';
import { useAuth } from './AuthContext';

const SPELHOUSE_INSTITUTIONS = ["Spelman College", "Morehouse College"];

const CommunityContext = createContext();

export const useCommunity = () => {
  const ctx = useContext(CommunityContext);
  if (!ctx) throw new Error('useCommunity must be used within CommunityProvider');
  return ctx;
};

export const CommunityProvider = ({ children }) => {
  const { user } = useAuth();
  const [communityView, setCommunityView] = useState('gradlink');

  const isSpelhouse = SPELHOUSE_INSTITUTIONS.includes(user?.institution);

  // Derive the institution filter params for API calls
  const institutionFilter = useMemo(() => {
    if (!user?.institution) return {};
    switch (communityView) {
      case 'school':
        return { institution: user.institution };
      case 'spelhouse':
        return { institution: SPELHOUSE_INSTITUTIONS.join(',') };
      case 'gradlink':
      default:
        return {};
    }
  }, [communityView, user?.institution]);

  const communityLabel = useMemo(() => {
    switch (communityView) {
      case 'school':
        return user?.institution || 'My School';
      case 'spelhouse':
        return 'SpelHouse';
      case 'gradlink':
        return 'All GradLink';
      default:
        return 'GradLink';
    }
  }, [communityView, user?.institution]);

  const communityOptions = useMemo(() => {
    const opts = [
      { value: 'school', label: user?.institution || 'My School' },
    ];
    if (isSpelhouse) {
      opts.push({ value: 'spelhouse', label: 'SpelHouse' });
    }
    opts.push({ value: 'gradlink', label: 'All GradLink' });
    return opts;
  }, [user?.institution, isSpelhouse]);

  return (
    <CommunityContext.Provider value={{
      communityView,
      setCommunityView,
      institutionFilter,
      communityLabel,
      communityOptions,
      isSpelhouse,
    }}>
      {children}
    </CommunityContext.Provider>
  );
};
